import { startOfDay, subDays, startOfMonth } from "date-fns"
import type { TDateRangePreset } from "./types"

const today = startOfDay(new Date())

export const defaultDateRangePresets: TDateRangePreset[] = [
  {
    label: "All",
    value: () => ({
      from: startOfDay(new Date(0)),
      to: today,
    }),
  },
  {
    label: "Today",
    value: () => ({
      from: today,
      to: today,
    }),
  },
  {
    label: "Month to date",
    value: () => ({
      from: startOfMonth(today),
      to: today,
    }),
  },
  {
    label: "Last 7 days",
    value: () => ({
      from: subDays(today, 7),
      to: today,
    }),
  },
  {
    label: "Last 30 days",
    value: () => ({
      from: subDays(today, 30),
      to: today,
    }),
  },
  {
    label: "Last 60 days",
    value: () => ({
      from: subDays(today, 60),
      to: today,
    }),
  },
  {
    label: "Last 90 days",
    value: () => ({
      from: subDays(today, 90),
      to: today,
    }),
    default: true,
  },
]
